import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import backend from 'i18next-http-backend';

import fr from './fr/translation';
import tr from './tr/translation';
import kr from './kr/translation';

i18n
// .use(backend)
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    resources: { fr, tr, kr },
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      addPath: 'http://localhost:4000/add?lng={{lng}}&ns={{ns}}',
    },
    saveMissing: true, // send not translated keys to endpoint
  });

export default i18n;
